import {ComponentProps} from 'react';
import clsx from 'clsx';
import {TrackedTab} from '@/components/tracked-atoms/tracked-tab';

type Props = ComponentProps<typeof TrackedTab> & {
  hasNotification?: boolean;
};

const HeaderItem = ({className, hasNotification = false, children, ...props}: Props) => {
  return (
    <TrackedTab
      className={clsx(
        'w-full rounded-2 px-6 py-3 text-base transition-colors hover:bg-purple-200 focus:bg-purple-200 data-[selected]:bg-white data-[selected]:text-violet',
        className,
      )}
      {...props}
    >
      {props => (
        <div className="relative inline-flex text-nowrap">
          {typeof children === 'function' ? children(props) : children}

          {hasNotification && <div className="absolute -right-3 -top-0 size-2 rounded-full bg-red"></div>}
        </div>
      )}
    </TrackedTab>
  );
};

export default HeaderItem;
